import { getFeature } from 'Cloud/Application/FeaturesEs6';

export const createPortfolioInFolder: 'a' | 'b' | 'c' = getFeature('create-portfolio-in-folder') || 'a';
